'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import dynamic from 'next/dynamic';
import React from 'react';
import DynamicComponent from '@repo/ui/src/components/DynamicComponent';
import { ModalID } from '@repo/ui/src/modules/UI';
import { useUI } from '@repo/ui/src/modules/UI/hooks/useUI';
import { CartDrawer } from '@components/Modals/components/CartDrawer';
import { LoginDrawer } from '@components/Modals/components/LoginDrawer';
import CheckoutLoader from '@components/Modals/components/CheckoutLoader';
import ShoppableIngredientsDrawer from '@components/Modals/components/ShoppableIngredientsDrawer';
import CountryModal from '@repo/ui/src/components/CountryModal';
import LearnMoreDrawer from '@components/LearnMoreDrawer';

const componentTypes: Omit<
  Record<ModalID, React.ComponentType>,
  'cart' | 'login' | 'country' | 'shoppable-ingredients' | 'learn-more'
> = {
  [ModalID.outOfStock]: dynamic(() => import('@components/Modals/components/OutOfStockModal')),
  [ModalID.error]: dynamic(() => import('@repo/ui/src/modules/UI/components/ErrorModal')),
  [ModalID.notifyMe]: dynamic(() => import('@components/Modals/components/NotifyMeModal')),
  [ModalID.image]: dynamic(() => import('@components/Modals/components/ImageModal')),
  [ModalID.grillRecommendation]: dynamic(
    () => import('@repo/ui/src/components/GrillRecommendationModal'),
  ),
  [ModalID.video]: dynamic(() => import('@components/Modals/components/VideoModal')),
  [ModalID.languageSelector]: dynamic(
    () => import('@repo/ui/src/components/LanguageSelector/LanguageSelectorModal'),
  ),
  [ModalID.checkoutLoader]: CheckoutLoader,
  [ModalID.gallery]: dynamic(() => import('@views/ProductDetailPage/_GalleryDialog')),
  [ModalID.threeSixtySpinViewer]: dynamic(() => import('@components/360Spin/_SpinDialog')),
};

const Modals = () => {
  const { openModalIds } = useUI();
  const { geo } = useCurrentUrl();
  return (
    <>
      <CartDrawer />
      <LoginDrawer />
      <CountryModal geo={geo!} />
      <ShoppableIngredientsDrawer />
      <LearnMoreDrawer />
      {openModalIds.map((id: string) => (
        <DynamicComponent key={id} _componentTypes={componentTypes} id={id} _field="id" />
      ))}
    </>
  );
};

export default Modals;
